import React from 'react'
import { Button, Card, CardBody, CardHeader, Col, Form, Row } from 'react-bootstrap'
import { useForm } from 'react-hook-form';

function ChangePassword() {
    const { register, handleSubmit,watch, formState: { errors, }, reset } = useForm({
        defaultValues: {
            currentPassword: "",
            newPassword: "",
            confirmPassword: "",
        },
    });

    const onSubmit = (data) => {
        console.log(data);
        alert('submit called');
        //Logic to save data
        handleCancel();
    }

    const handleCancel = (e) => {
        console.log('cancel clicked');
        reset({ currentPassword: '', newPassword: '', confirmPassword: '' });
    }

    return (
        <Row>
            <Col md={12}>
                <Card className='mb-4'>
                    <CardHeader className='pb-0'>
                        <Row>
                            <h4>Change Password</h4>

                        </Row>
                    </CardHeader>
                    <CardBody className='px-0 pt-0 pb-2'>
                        <Form onSubmit={handleSubmit(onSubmit)} className='p-3'>
                            <Row className="mb-3">
                                <Form.Group controlId="currentPassword" className="col-md-6 col-sm-12">
                                    <Form.Label>Current password <span className='text-danger'>*</span></Form.Label>
                                    <Form.Control type="password" placeholder="Current password" {...register("currentPassword", { required: "Current password is required." })} />
                                    <span className='text-xs text-danger'>{errors.currentPassword?.message}</span>
                                </Form.Group>
                            </Row>
                            <Row className="mb-3">
                                <Form.Group controlId="newPassword" className="col-md-6 col-sm-12">
                                    <Form.Label>New password <span className='text-danger'>*</span></Form.Label>
                                    <Form.Control type="password" placeholder="New password" {...register("newPassword", { required: "New password is required." })} />
                                    <span className='text-xs text-danger'>{errors.newPassword?.message}</span>
                                </Form.Group>
                            </Row>
                            <Row className="mb-3">
                                <Form.Group controlId="confirmPassword" className="col-md-6 col-sm-12">
                                    <Form.Label>Confirm password <span className='text-danger'>*</span></Form.Label>
                                    <Form.Control type="password" placeholder="Confirm password" {...register("confirmPassword", { required: "Confirm password is required.",  validate: value => value === watch('newPassword') || "Password and confirm pasword does not match.",})} />
                                    <span className='text-xs text-danger'>{errors.confirmPassword?.message}</span>
                                </Form.Group>
                            </Row>

                            <Row >
                                <Col md={12} className='d-grid gap-2 d-md-flex flex-md-row-reverse'>
                                    <Button variant="primary" className='me-md-2' type="submit">Submit</Button>
                                    <Button variant="dark" type="button" onClick={handleCancel}>Cancel</Button>
                                </Col>
                            </Row>

                        </Form>
                    </CardBody>
                </Card>
            </Col>
        </Row>
    )
}

export default ChangePassword